import { useEffect } from 'react';
import { initializeStore } from '@/lib/store';
import Dashboard from '@/components/dashboard/Dashboard';
import { useAppStore } from '@/lib/store';

function App() {
  const { fetchChainParams, fetchTrxPrice } = useAppStore();

  useEffect(() => {
    // Initialize the store and fetch data
    initializeStore();
  }, []);

  useEffect(() => {
    // Fetch chain parameters and TRX price when component mounts
    fetchChainParams();
    fetchTrxPrice();
  }, [fetchChainParams, fetchTrxPrice]);

  return (
    <div className="min-h-screen bg-background">
      <Dashboard />
    </div>
  );
}

export default App;
